const firebaseConfig = {
    apiKey: "AIzaSyAkbb65YVrQbfnBhUqjn73B0_GealcStPE",
    authDomain: "we-care-hospital.firebaseapp.com",
    projectId: "we-care-hospital",
    storageBucket: "we-care-hospital.appspot.com",
    messagingSenderId: "486283660946",
    appId: "1:486283660946:web:e6c7352b53e0c2ac03604b"
};

export default firebaseConfig;